
// SVG Icon: cancel
export default { id: "terriajs-cancel" };
export const id = "terriajs-cancel";
export const name = "cancel";
